import { Scene, MeshBuilder, StandardMaterial, Vector3, Mesh } from '@babylonjs/core';
import { FLOOR_SIZE } from '../utils/constants';

export function createFloor(scene: Scene): Mesh {
  const floor = MeshBuilder.CreateGround('floorMesh', {
    width: FLOOR_SIZE,
    height: FLOOR_SIZE
  }, scene);

  floor.position = new Vector3(0, 0, 0);

  // Invisible material for AR (floor is just a teleportation landing zone)
  const material = new StandardMaterial('floorMaterial', scene);
  material.alpha = 0;
  floor.material = material;

  // Ensure the mesh is still pickable for teleportation even though invisible
  floor.isPickable = true;
  floor.isVisible = true;

  return floor;
}
